import { Component, Input } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { ToastrService } from 'ngx-toastr';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../../comun/models/misdatos.model';
import { MisdatosService } from '../../comun/services/misdatos.service';
import { PerfilService } from '../../comun/services/perfil.service';
declare var bootstrap: any;

@Component({
  selector: 'app-compartir-modal',
  templateUrl: './compartir-modal.component.html',
  styleUrl: './compartir-modal.component.css'
})
export class CompartirModalComponent {
  @Input() userid: number = 0;
  @Input() slug: number = 0;
  private misdatosSub!: Subscription;
  misdatos: any = {};
  private perfilSub!: Subscription;
  perfil: any = {};
  amigos: any[] = [];
  amigosFiltrados: any[] = [];
  textoBusqueda: string = '';
  loadingamigos: boolean = true;
  global: any = GlobalConstants;

  constructor(private query: QueryService, 
              private toastr: ToastrService, 
              private misdatosService: MisdatosService, 
              private perfilService: PerfilService) {}

  ngAfterViewInit() {
    const modal = document.getElementById('compartirModal');
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        this.getMisDatos();
      });
      const handler = () => {
        this.amigos.length = 0;
        this.amigos = [];
        this.amigosFiltrados = this.amigos;
        this.loadingamigos = true;
        //window.location.reload();
      };
      modal?.addEventListener('hidden.bs.modal', handler, { once: false });
    }
  }

  getMisDatos() {
    this.loadingamigos = true;
    // 1. Escuchamos el observable perfil$
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        this.getPerfil();        
      });
    /*this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      this.getPerfil();
    });*/
  }

  getPerfil() {
    // 1. Escuchamos el observable
    this.perfilSub = this.perfilService.perfil$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((perfil): perfil is UsuarioPerfil => perfil !== null)
      )
      .subscribe((perfil: UsuarioPerfil) => {
        // Ya tenemos datos
        this.perfil = perfil;
        this.getAmigos();
      });
    /*if (this.userid == this.misdatos.ID) {
      this.perfil = this.misdatos;
      this.getAmigos();
    } else {
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        this.getAmigos();
      });
    }*/
  }

  getAmigos() {
    this.query.query('seguir', 'GET', { ID: this.misdatos.ID }).subscribe((resultado:any) => {
      this.amigos = resultado.registros;
      this.amigosFiltrados = this.amigos;
      this.loadingamigos = false;
    });
  }

  filtrarAmigos() {

    const texto = this.textoBusqueda.toLowerCase().trim();

    if (!texto) {
      this.amigosFiltrados = this.amigos;
      return;
    }

    this.amigosFiltrados = this.amigos.filter((amigo: any) => {

      const mascota = amigo?.mascota?.ma_nombre?.toLowerCase() || '';
      const usuario = amigo?.first_name?.toLowerCase() || '';
      const ciudad = amigo?.ciudad?.toLowerCase() || '';

      return (
        mascota.includes(texto) ||
        usuario.includes(texto) ||
        ciudad.includes(texto)
      );

    });

  }

  copiarSlug() {
    navigator.clipboard.writeText(GlobalConstants.urlServer + 'perfil/' + this.perfil.slug)
    .then(() => {
      this.toastr.success('Dirección Url copiada al portapapeles', 'Aviso');
    })
    .catch(err => {
      this.toastr.error('Error al copiar al portapapeles', 'Error');
    });        
  }

  seleccionarAmigo(amigo: any) {
    amigo.checked = !amigo.checked;
  }

  amigosSeleccionados() {
    return this.amigos.filter((amigo: any) => amigo.checked );
  }

  compartirPerfil() {
    const amigoschecked = this.amigosSeleccionados();

    if (amigoschecked.length == 0) {
      this.toastr.warning('Selecciona algún amigo con quien compartir', 'Aviso');
      return;
    } else {
      amigoschecked.forEach(amigo => {
        // Enviar email
        let contenido = '<p>Hola ' + amigo.first_name + ',<br>' +
                        this.misdatos.first_name + ' ha compartido contigo el perfil de <b>' + this.perfil.first_name + '</b></p>' +
                        '<p>' +
                        '<b><a href="' + GlobalConstants.urlServer + 'perfil/' + this.perfil.slug + '" target="_blank">Ver perfil</a></b>' +
                        '</p>' +
                        '<p>Un saludo,<br>El equipo de iGuau</p>';
        let texto = this.misdatos.first_name + ' ha compartido contigo el perfil de <b>' + this.perfil.first_name + '</b>' +
                    '<br><b><a href="' + GlobalConstants.urlServer + 'perfil/' + this.perfil.slug + '" target="_blank">Ver perfil</a></b>';
        let params = { plantilla: 'general.html',
                      us_id_from: this.misdatos.ID,
                      us_id: amigo.se_us_id, // administradores
                      tipo: 'ACTIVIDAD',
                      asunto: 'Perfil compartirdo en iGuau',
                      contenido: contenido,
                      texto: texto,
                      botonurl: GlobalConstants.urlWeb,
                      boton: 'Ir a iGuau',
                      estado: 'pendiente',
                      contacto: '' // al email de contacto del usuario
                    };
        this.query.enviarMail(params).subscribe((resultado:any) => {
          // Avisamos a Firebase para notificar al otro usuario
          //this.chatService.enviarMensaje(resultado.id.toString(), this.misdatos.ID.toString(), amigo.se_us_id.toString(), 'COMPARTIR_PERFIL');
        });
      });
      const modalElement = document.getElementById('compartirModal');
      if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        modalInstance?.hide();
      }
      this.toastr.success('Perfil compartido', 'Aviso');
    }
  }

}
